module.exports = __webpack_public_path__ + "images/help_v2/case-tower-8fe88d30b9db7e2ee9cd1c7d0f9b0f49.jpg";